import React, {useEffect, useRef} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import FacebookImport from "./FacebookImport";
import InfoText from "../../../../util/common/InfoText";
import {connect} from "react-redux";
import {getImportSources} from "../../../../../state/actions/getDataActions";

const useStyles = makeStyles({
  root:{
    display: "flex",
    flexWrap: "wrap",
    gap: "1rem",
    maxWidth:"550px",
    margin: "0 auto",
    marginBottom: "1rem",
  },
  content:{
    flexBasis: "10.5em",
    flexGrow: 1
  },
  label:{
    fontSize: "0.85rem",
    fontWeight: "500",
    opacity: "0.87",
    textAlign: "center",
    width: "fit-content",
    marginBottom: "0.15rem"
  },
  container:{
    display: "flex",
    flexWrap: "wrap",
    gap: "1rem",
  },
});


function ImportBar(props) {
  const { fetchItems, mid, importSources, getImportSources } = props;
  const classes = useStyles();
  const refreshTimeout = useRef(null);
  const itemCounts = useRef(null);
  const active = useRef(false);

  const {facebook={}, instagram={}, twitter={}} = importSources;
  active.current = (facebook.status === "active" || instagram.status === "active" || twitter.status === "active");

  const fetchSources = () => {
    if(active.current ) {
      refreshTimeout.current = setTimeout(() => {
        getImportSources(mid, () => {
          if(active.current) {
            fetchSources();
          }else{
            clearTimeout(refreshTimeout.current);
            refreshTimeout.current = null;
          }
        });
      }, 1000);
    }
  }

  if(active.current  && !refreshTimeout.current){
    fetchSources();
  }else if(!active.current && !!refreshTimeout.current){
    clearTimeout(refreshTimeout.current);
    refreshTimeout.current = null;
  }

  useEffect(() => {
    getImportSources(mid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  useEffect(() => {
    if(itemCounts.current === null){
      itemCounts.current = [facebook.item_count, instagram.item_count, twitter.item_count];
      return;
    }
    if(facebook.item_count === null && instagram.item_count === null && twitter.item_count === null){
      return
    }
    if((facebook.item_count !== itemCounts.current[0] && itemCounts.current[0] !== null) ||
        (instagram.item_count !== itemCounts.current[1] && itemCounts.current[1] !== null) ||
        (twitter.item_count !== itemCounts.current[2] && itemCounts.current[2] !== null)){
      itemCounts.current = [facebook.item_count, instagram.item_count, twitter.item_count];
      fetchItems();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facebook.item_count, instagram.item_count, twitter.item_count])

  return (
      <div className={classes.root}>
        <div className={classes.content}>
          <div className={classes.label}>
            Import from Social Media
          </div>
          <InfoText className={classes.message}>
            <div>Click a button to connect.</div>
            <div>A new window will open to login and allow access.</div>
            <div style={{marginTop: "0.5rem"}}>After connecting, click again to begin importing.</div>
          </InfoText>
        </div>
        <div className={classes.container}>
          <FacebookImport importSource={facebook} />
          {/*<InstagramImport importSource={instagram} />*/}
          {/*<TwitterImport importSource={twitter} />*/}
        </div>
      </div>
  );
}

const mapStateToProps = state => {
  return {
    mid: state.mindfile.id,
    importSources: state.importSources
  };
};

const mapDispatchToProps = {
  getImportSources
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportBar);
